import React, { Fragment, useEffect, useState } from "react";
import { closeModal } from "../../store/modal/modalReducer";
import { useDispatch } from "react-redux";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { faLoader, faCircleXmark } from "@fortawesome/pro-solid-svg-icons";
import { faUserShield } from "@fortawesome/pro-regular-svg-icons";
import { toast } from "react-toastify";
import { Dialog, Transition } from "@headlessui/react";
import ErrorBoundary from "../../containers/ErrorBoundary";
import FileDisplay from "../Forms/FileDisplay";
import ViewFile from "../Helpers/ViewFile";

export default function ModalViewFiles(props) {
  const [loading, setLoading] = useState(true);
  const [files, setFiles] = useState([]);
  const [numPages, setNumPages] = useState(null);
  const [sendingToBiometrics, setSendingToBiometrics] = useState(false);
  const dispatch = useDispatch();
  const [open] = useState(true);
  let file_request = [];
  console.log(props);

  props.files.map((file) => {
    file_request.push(file.id);
  });

  useEffect(() => {
    if (file_request) {
      axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}view_files`,
        data: file_request,
      })
        .then((response) => {
          setFiles(response.data);
          setLoading(false);
        })
        .catch(() => {
          setFiles([]);
          setLoading(false);
        });
    }
  }, [setFiles]);

  const sendToBiometrics = async (file) => {
    try {
      setSendingToBiometrics(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}update-biometrics-image`,
        {
          file_id: file.id,
          image_data: file.content,
          booking_id: props.booking_id,
        },
      );

      if (response.data.success) {
        // Show success message with vehicle info if available
        let successMessage = "Biometrics image updated successfully";

        if (
          response.data.vehicles_pushed > 0 ||
          response.data.vehicles_failed > 0
        ) {
          successMessage += `\n🚗 Vehicles: ${response.data.vehicles_pushed} pushed`;
          if (response.data.vehicles_failed > 0) {
            successMessage += `, ${response.data.vehicles_failed} failed`;
          }
        }

        toast.success(successMessage);
      } else {
        throw new Error(
          response.data.message || "Failed to update biometrics image",
        );
      }
    } catch (error) {
      console.error("Error updating biometrics image:", error);
      toast.error(
        error.response?.data?.message || "Failed to update biometrics image",
      );
    } finally {
      setSendingToBiometrics(false);
    }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed z-50 inset-0 overflow-y-auto"
        open={open}
        onClose={() => dispatch(closeModal())}
      >
        <ErrorBoundary>
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-[80vw] sm:p-6">
                <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                  <button
                    type="button"
                    className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-0"
                    onClick={() => dispatch(closeModal())}
                  >
                    <span className="sr-only">Close</span>
                    <FontAwesomeIcon
                      className="h-6 w-6"
                      aria-hidden="true"
                      icon={faTimes}
                    />
                  </button>
                </div>
                {loading && (
                  <FontAwesomeIcon
                    className="h-10 w-10 text-gray-900 animate-spin ml-52"
                    icon={faLoader}
                  />
                )}
                {!loading && files.empty && <p>No files found</p>}

                {!files.empty ? (
                  files.map((file) => (
                    <div
                      key={file.id}
                      className="py-4 text-center sm:mt-0 sm:ml-4 sm:text-left"
                    >
                      {!file.encrypted ? (
                        <div>
                          <FileDisplay
                            file={file}
                            key={file.id}
                            callback={true}
                          />
                          {file.type.includes("pdf") && (
                            <ViewFile file={file} />
                          )}
                          {file.type.includes("image") && (
                            <div className="relative">
                              <img
                                src={`data:image/jpg;base64,${file.content}`}
                                alt="image"
                              />
                              <button
                                className="absolute top-2 right-2 bg-white p-2 rounded-full shadow-md hover:bg-gray-100"
                                title="Send to Biometrics"
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      "This will replace the current biometrics image. Are you sure?",
                                    )
                                  ) {
                                    sendToBiometrics(file);
                                  }
                                }}
                                disabled={sendingToBiometrics}
                              >
                                <FontAwesomeIcon
                                  icon={
                                    sendingToBiometrics
                                      ? faLoader
                                      : faUserShield
                                  }
                                  className={`h-5 w-5 ${
                                    sendingToBiometrics ? "animate-spin" : ""
                                  }`}
                                />
                              </button>
                            </div>
                          )}

                          {file.type.includes("audio") && (
                            <div className="mt-4">
                              <audio controls className="w-full">
                                <source src={file.url} type={file.type} />
                                Your browser does not support the audio element.
                              </audio>
                            </div>
                          )}

                          {!file.type.includes("image") &&
                            !file.type.includes("pdf") &&
                            !file.type.includes("audio") && (
                              <div className="flex items-center bg-red-100 rounded-md p-4">
                                <FontAwesomeIcon
                                  className="h-4 w-4 text-red-800 mr-4"
                                  icon={faCircleXmark}
                                />

                                {file.type.includes("null") ? (
                                  <>
                                    <p className="text-red-800">
                                      This file is corrupted.
                                    </p>
                                    <p className="text-red-800">
                                      {" "}
                                      Please request a new file and delete this
                                      one
                                    </p>
                                  </>
                                ) : (
                                  <>
                                    <p className="text-red-800">
                                      Format cannot be translated.
                                    </p>
                                    <p className="text-red-800">
                                      {" "}
                                      Please download the file.
                                    </p>
                                  </>
                                )}
                              </div>
                            )}
                        </div>
                      ) : (
                        <>
                          <FileDisplay
                            file={file}
                            key={file.id}
                            callback={true}
                          />
                          <div className="flex items-center bg-red-100 rounded-md p-4">
                            <FontAwesomeIcon
                              className="h-4 w-4 text-red-800 mr-4"
                              icon={faCircleXmark}
                            />
                            <p className="text-red-800">
                              The File is Encrypted. Please download the file
                              and use the password.
                            </p>
                          </div>
                        </>
                      )}
                    </div>
                  ))
                ) : (
                  <Dialog.Title
                    as="h1"
                    className="text-lg font-medium text-gray-900"
                  >
                    No Files has been uploaded
                  </Dialog.Title>
                )}
              </div>
            </Transition.Child>
          </div>
        </ErrorBoundary>
      </Dialog>
    </Transition.Root>
  );
}
